/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateRemoveEdgeEdgeKeyMax = 200;

export const mutateRemoveEdgeExpectedOutgoingRevisionMax = 128;

export const MutateRemoveEdge = zod.object({
  edgeKey: zod
    .string()
    .max(mutateRemoveEdgeEdgeKeyMax)
    .nullable()
    .describe(
      'The slot key you expect this edge to carry, or null for an edge you expect to be unkeyed. Checked, not ignored.',
    ),
  edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
  expectedOutgoingRevision: zod
    .string()
    .min(1)
    .max(mutateRemoveEdgeExpectedOutgoingRevisionMax)
    .optional()
    .describe(
      'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
    ),
  fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
  toContentUuid: zod.uuid().describe('UUID v4 identifier'),
});

export type MutateRemoveEdge = zod.input<typeof MutateRemoveEdge>;
export type MutateRemoveEdgeOutput = zod.output<typeof MutateRemoveEdge>;
